// src/pages/Payments.tsx
import React from 'react';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../../firebase/config'; // Adjust path if needed
import { usePageTitle } from '../../hooks/usePageTitle';

export default function Payments() {
  usePageTitle('Payments | From the Pitchside');
  const handleConnectStripe = async () => {
    try {
      const callable = httpsCallable(functions, 'createStripeConnectLink');
      const result = await callable({
        clubId: 'your-club-id',
        teamId: 'your-team-id',
      });
      const { url } = result.data as { url: string };
      console.log('🔗 Stripe URL:', url);
      window.location.href = url;
    } catch (error: any) {
      console.error('❌ Error creating Stripe link:', error.message || error);
      alert('There was an issue connecting to Stripe.');
    }
  };

  return (
    <div style={{ padding: '2rem' }} className="text-darkblue">
      <h1>Payments Test</h1>
      <button onClick={handleConnectStripe}>Connect Stripe</button>
    </div>
  );
}
